module.exports = __webpack_public_path__ + "files/a3219fcba3c02cb7068519a1bd25bb47.png";